var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"mainiframe",staticStyle:{"height":"100vh","width":"100vw"},attrs:{"src":_vm.pdfUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }